import { styled } from 'linaria/react';

export const ComplementaryProductsBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ComplimentaryProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
  width: 100%;
`;

export const ComplimentaryProductImg = styled.img`
  cursor: pointer;
`;

export const AddedProductsTitle = styled.div`
  margin: var(--space-300) 0 var(--space-150) 0;
`;

export const ComplimentaryProductInfoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    gap: var(--space-200);
  }
`;

export const ComplimentaryProductInfoTitle = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
  width: 66.5%;

  @media (--only-mobile) {
    align-items: flex-start;
    width: 100%;
  }
`;

export const PriceAndCounterBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-100);
  width: 35.5%;

  @media (--only-mobile) {
    width: 100%;
  }
`;
